const ADDITIONAL_RECEIVERS_PLACEHOLDER_TEXT =
  'Ex: Pode entregar para Manuela da Silva, casa 2';

const CONTINUE_BUTTON_TEXT = 'Salvar e Continuar';

const CONTINUE_BUTTON_DATA_TEST_ID = 'continue-btn';

export {
  CONTINUE_BUTTON_DATA_TEST_ID,
  CONTINUE_BUTTON_TEXT,
  ADDITIONAL_RECEIVERS_PLACEHOLDER_TEXT
};
